import { render, staticRenderFns } from "./sortedBlock.vue?vue&type=template&id=58b460e4&scoped=true&"
import script from "./sortedBlock.vue?vue&type=script&lang=js&"
export * from "./sortedBlock.vue?vue&type=script&lang=js&"
import style0 from "./sortedBlock.vue?vue&type=style&index=0&id=58b460e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b460e4",
  null
  
)

export default component.exports